if (!customElements.get('pawce-fabric-demo')) {
  customElements.define('pawce-fabric-demo', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.timers = [];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const opts = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const mode = event.target.closest('[data-demo-mode]');
        const step = event.target.closest('[data-demo-step]');
        if (mode) {
          this.stop(); this.setMode(mode.dataset.demoMode);
          if (mode.dataset.demoMode === 'treat') this.play();
          else {
            this.setStage(0);
            if (!this.motion.matches) {
              this.running = true; this.dataset.playing = 'true'; this.updateLabel();
              this.timers.push(setTimeout(() => this.stop(), 6200));
            }
          }
        }
        if (step) { this.stop(); this.setMode('treat'); this.setStage(Number(step.dataset.demoStep)); }
        if (event.target.closest('[data-demo-play]')) this.running ? this.stop() : this.play();
      }, opts);
      this.motion.addEventListener('change', () => { if (this.motion.matches) { this.stop(); this.setStage(2); } }, opts);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, opts);
      document.addEventListener('shopify:block:select', event => {
        const step = event.target.closest('[data-demo-step]');
        if (step && this.contains(step)) { this.stop(); this.setMode('treat'); this.setStage(Number(step.dataset.demoStep)); }
      }, opts);
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting && !this.started) { this.started = true; if (!this.motion.matches) this.play(); }
          if (!entry.isIntersecting) this.stop();
        }
      }, { threshold: 0.3 });
      this.observer.observe(this.querySelector('.pw-fabric__lab'));
    }
    disconnectedCallback() { this.stop(); this.controller?.abort(); this.observer?.disconnect(); }
    setMode(mode) {
      this.dataset.mode = mode;
      this.querySelectorAll('[data-demo-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.demoMode === mode)));
    }
    setStage(stage) {
      this.dataset.stage = stage;
      this.querySelectorAll('[data-demo-step]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.demoStep) === stage)));
    }
    play() {
      this.stop(); this.setMode('treat');
      if (this.motion.matches) { this.setStage(2); return; }
      this.running = true; this.dataset.playing = 'true'; this.setStage(0); this.updateLabel();
      this.timers.push(setTimeout(() => this.setStage(1), 1200), setTimeout(() => this.setStage(2), 4100), setTimeout(() => this.stop(), 6200));
    }
    stop() { this.timers?.forEach(clearTimeout); this.timers = []; this.running = false; this.dataset.playing = 'false'; this.updateLabel(); }
    updateLabel() {
      const button = this.querySelector('[data-demo-play]');
      if (button) button.querySelector('[data-play-text]').textContent = this.running ? button.dataset.pauseLabel : button.dataset.playLabel;
    }
  });
}
